
export enum ConsigneeUnloadedTrailerCd {
	NOT_UNLD_BY_CONS = 'NotUnldByCons',
	TRAILER_NOT_UNLD = 'TrailerNotUnld',
	UNLD_BY_CONS = 'UnldByCons'}
